var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.addFile{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "addFile",
    d: "M14.26,3h-1.25V1.75c0-0.41-0.34-0.75-0.75-0.75s-0.75,0.34-0.75,0.75V3h-1.25C9.84,3,9.51,3.34,9.51,3.75 c0,0.41,0.33,0.75,0.75,0.75h1.25v1.25c0,0.41,0.34,0.75,0.75,0.75s0.75-0.34,0.75-0.75V4.5h1.25c0.41,0,0.75-0.34,0.75-0.75 S14.67,3,14.26,3z M12.26,7.68c-0.41,0-0.75,0.34-0.75,0.75v5.07h-7v-11h3.75c0.41,0,0.75-0.34,0.75-0.75S8.67,1,8.26,1h-4.5 C3.34,1,3.01,1.34,3.01,1.75v12.5c0,0.41,0.34,0.75,0.75,0.75h8.5c0.41,0,0.75-0.34,0.75-0.75V8.43 C13.01,8.01,12.67,7.68,12.26,7.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddFile);
export default __webpack_public_path__ + "static/media/icon_addFile.7f127a82b99065f0b2bd150b7f816701.svg";
export { ForwardRef as ReactComponent };